"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuSection = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");
var react_1 = tslib_1.__importStar(require("react"));
var context_1 = require("../context");
var section_1 = require("../styled/section");
var MenuSection = function (_a) {
    var __UIScope = _a.__UIScope, className = _a.className, testID = _a["data-testid"], label = _a.label, _b = _a.headingLevel, headingLevel = _b === void 0 ? 3 : _b;
    var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
        block: 'MenuSection',
        className: className,
        __UIScope: __UIScope,
    }).rootClasses;
    var isInverse = (0, react_1.useContext)(context_1.MenuContext).isInverse;
    return (react_1.default.createElement(section_1.Section, { className: rootClasses, "data-testid": testID, isInverse: isInverse, element: "h".concat(headingLevel), pattern: "captionMedium", color: "grey-medium" }, label));
};
var MenuSectionWithSpace = (0, ui_helper_with_space_1.withSpace)(MenuSection);
exports.MenuSection = MenuSectionWithSpace;
//# sourceMappingURL=menu-section.js.map